const LOWER_WORDS = new Set(['de', 'del', 'la', 'las', 'los', 'y', 'e']);
// Mexican company suffixes that should stay uppercase.
const UPPER_TOKENS = new Set(['S', 'A', 'SA', 'RL', 'CV', 'SC', 'SAPI', 'SAS', 'AC', 'DE']);

/**
 * Normalizes names captured in mixed casing ("JESUS ARMANDO GARCIA NAVA")
 * to title case for display. Company names keep their legal suffix uppercase
 * ("Cynga Comunicaciones S DE RL DE CV").
 */
export function formatPersonName(name: string | null | undefined): string {
  if (!name) return '';
  const trimmed = name.trim().replace(/\s+/g, ' ');
  if (trimmed.includes('@')) return trimmed;
  const words = trimmed.split(' ');
  const suffixStart = words.findIndex((w, i) => i > 0 && /^(S|SA|SAPI|SAS|SC|AC)$/i.test(w.replace(/\./g, '')));
  return words
    .map((word, index) => {
      const bare = word.replace(/\./g, '').toUpperCase();
      if (suffixStart !== -1 && index >= suffixStart && UPPER_TOKENS.has(bare)) return word.toUpperCase();
      const lower = word.toLocaleLowerCase('es-MX');
      if (index > 0 && LOWER_WORDS.has(lower)) return lower;
      return lower.charAt(0).toLocaleUpperCase('es-MX') + lower.slice(1);
    })
    .join(' ');
}
